import api from "./api.js";

export default class TermsApi {
  static async create(data) {
    return await api.post(`term`, data);
  }
  static async getList(params) {
    return await api.get(`term`, params);
  }
  static async getById(termsId) {
    return await api.get(`term/${termsId}`);
  }
  static async update(termsId, data) {
    return await api.patch(`term/${termsId}`, data);
  }
  static async delete(idList) {
    return await api.del(`term?idList=${idList}`);
  }
}
